<template>
  <svg width="29" height="38" viewBox="0 0 29 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.7412 2.16L14.5 0L10.2588 2.16L5.53724 2.865L3.39756 7.065L0 10.365L0.777602 15L0 19.635L3.39756 22.935L5.53724 27.135L10.2588 27.84L14.5 30L18.7412 27.84L23.4628 27.135L25.6024 22.935L29 19.635L28.2224 15L29 10.365L25.6024 7.065L23.4628 2.865L18.7412 2.16ZM21.7805 5.1425L17.9433 4.57L14.5 2.815L11.0567 4.57L7.21951 5.1425L5.48134 8.555L2.72161 11.235L3.35436 15L2.71907 18.765L5.48134 21.445L7.21951 24.8575L11.0567 25.43L14.5 27.185L17.9458 25.43L21.7805 24.8575L23.5187 21.445L26.2784 18.765L25.6482 15L26.2784 11.235L23.5187 8.555L21.7805 5.1425Z"
    />
    <path d="M5 30V38L14.5 36.098L24 38V30L19.2073 30.582L14.5 32.5335L9.79275 30.582L5 30Z" />
  </svg>
</template>

<script>
export default {
  name: 'CertifiedExpertsSvg'
}
</script>

<style scoped>
svg {
  fill: var(--color-green);
}
</style>
